"use client";

import React from "react";
import { trackEvent } from "@/lib/track";
import { StyledSection } from "./chatbotPlans.styles";

export interface IChatbotPlan {
  tier: string;
  price: string;
  cadence?: string;
  badge?: string;
  headline: string;
  features: string[];
  featured?: boolean;
}

interface IChatbotPlansProps {
  title?: string;
  intro?: string;
  plans: IChatbotPlan[];
  ctaHref: string;
  ctaText?: string;
  footnote?: string;
  eventName?: string;
}

export const ChatbotPlans = ({
  title = "What free actually gets you",
  intro,
  plans,
  ctaHref,
  ctaText = "Start free",
  footnote,
  eventName,
}: IChatbotPlansProps) => {
  if (!plans.length) return null;

  return (
    <StyledSection>
      <div className="inner">
        <header>
          <h2>{title}</h2>
          {intro ? <p>{intro}</p> : null}
        </header>

        <ul className="grid">
          {plans.map((p) => (
            <li key={p.tier} className={`plan${p.featured ? " featured" : ""}`}>
              {p.badge ? <span className="badge">{p.badge}</span> : null}
              <h3 className="tier">{p.tier}</h3>
              <p className="price">
                {p.price}
                {p.cadence ? <small> {p.cadence}</small> : null}
              </p>
              <p className="headline">{p.headline}</p>
              <ul>
                {p.features.map((f) => (
                  <li key={f}>{f}</li>
                ))}
              </ul>
              <a
                href={ctaHref}
                onClick={() => {
                  if (eventName) trackEvent(eventName, { tier: p.tier });
                }}
              >
                {p.featured ? ctaText : "Choose " + p.tier}
              </a>
            </li>
          ))}
        </ul>

        {footnote ? <p className="footnote">{footnote}</p> : null}
      </div>
    </StyledSection>
  );
};
